export default __webpack_public_path__ + "static/media/lionFill.d2d7751e.svg";